import { createSlice } from "@reduxjs/toolkit";
import { reducers, initialState } from "./reducers/classImporterReducers";

export const ClassImporterSlice = createSlice({
  name: "classImporter",
  initialState,
  reducers,
});

export const { setSelectedCourse, clearSelectedCourse } =
  ClassImporterSlice.actions;
export default ClassImporterSlice.reducer;
